import { ComponentProps } from "react";

import { Box } from "@design-system/Box/Box";
import { Icon } from "@design-system/Icon/Icon";
import { IconButton } from "@design-system/IconButton/IconButton";
import { Skeleton } from "@design-system/Skeleton/Skeleton";
import { Text } from "@design-system/Text/Text";

import classes from "./Stat.module.css";

type Props = {
  icon: ComponentProps<typeof Icon>["icon"];
  title: string;
  value: string;
  isLoading?: boolean;
  onOpenDetails?: () => void;
};

export const Stat = ({
  icon,
  title,
  value,
  isLoading = false,
  onOpenDetails,
}: Props) => {
  return (
    <div className={classes.container}>
      <div className={classes.icon}>
        <Icon icon={icon} />
      </div>
      <div className={classes.content}>
        <Text color="primary" size={11} weight={800} uppercase>
          {title}
        </Text>
        {isLoading ? (
          <Skeleton baseColor="transparent" width="50%" height={28} />
        ) : (
          <Text size={24} weight={700} color="textSecondary">
            {value}
          </Text>
        )}
      </div>

      {onOpenDetails && (
        <div className={classes.offsetInfoIcon}>
          <Box>
            <IconButton icon="faCircleInfo" size="sm" onClick={onOpenDetails} />
          </Box>
        </div>
      )}
    </div>
  );
};
